const carousels = async function () {
    const brandCarousel = [...document.querySelectorAll(".brands-carousel")];
    const imageAndContentCarousel = [...document.querySelectorAll(".image-and-content-carousel")];
    const bannerCarousel = [...document.querySelectorAll(".banner-carousel")];

    if (brandCarousel || imageAndContentCarousel || bannerCarousel) {
        const Swiper = await (await import("swiper/bundle")).default;

        if (brandCarousel) {
            brandCarousel.forEach(section => {
                const carousel = new Swiper(section.querySelector(".swiper"), {
                    loop: true,
                    lazy: true,
                    simulateTouch: false,
                    allowTouchMove: false,
                    freeMode: true,
                    speed: 5000,
                    autoplay: {
                        delay: 0,
                        disableOnInteraction: false,
                    },
                    slidesPerView: 5,
                    spaceBetween: 87,
                    breakpoints: {
                        768: {
                            slidesPerView: 3,
                        },
                        1024: {
                            slidesPerView: 4,
                        },
                        1280: {
                            slidesPerView: 5,
                        }
                    },
                })
            })
        }
        
        if (imageAndContentCarousel) {
            imageAndContentCarousel.forEach(section => {
                const multiSlide = section.querySelectorAll(".swiper-bg .swiper-slide:not(.swiper-slide-duplicate)").length > 1;
                
                const carouselBg = new Swiper(section.querySelector(".swiper-bg"), {
                    loop: true,
                    lazy: true,
                    simulateTouch: multiSlide,
                    allowTouchMove: multiSlide,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true,
                    },
                    watchSlidesProgress: true,
                    speed: 750,
                    slidesPerView: 1,
                })

                const carouselContent = new Swiper(section.querySelector(".swiper-content"), {
                    loop: true,
                    speed: 750,
                    slidesPerView: 1,
                    watchSlidesProgress: true,
                    effect: "creative",
                    simulateTouch: multiSlide,
                    allowTouchMove: multiSlide,
                    creativeEffect: {
                        prev: {
                            translate: ["-100%", 0, 0],
                            // opacity: 0,
                            scale: 0.9,
                        },
                        next: {
                            translate: ["100%", 0, 0],
                            // opacity: 0,
                            scale: 0.9,
                        },
                    },
                    navigation: {
                        prevEl: section.querySelector(".swiper-button-prev"),
                        nextEl: section.querySelector(".swiper-button-next"),
                    },
                    pagination: {
                        el: section.querySelector(".swiper-pagination"),
                        clickable: true,
                    },
                });


                carouselContent.controller.control = carouselBg;
                carouselBg.controller.control = carouselContent;
            })
        }
        
        if (bannerCarousel) {
            bannerCarousel.forEach(section => {
                const multiSlide = section.querySelectorAll(".swiper-bg .swiper-slide:not(.swiper-slide-duplicate)").length > 1;
                
                const carouselBg = new Swiper(section.querySelector(".swiper-bg"), {
                    loop: true,
                    lazy: true,
                    speed: 800,
                    loopedSlides: 3,
                    slidesPerView: 1,
                    spaceBetween: 0,
                    simulateTouch: multiSlide,
                    allowTouchMove: multiSlide,
                    on: {
                        slideChange(swiper) {
                            section.querySelector(".banner-carousel__caption").innerHTML = swiper.slides[swiper.activeIndex].dataset.caption;
                        }
                    },
                    navigation: {
                        prevEl: section.querySelector(".swiper-button-prev"),
                        nextEl: section.querySelector(".swiper-button-next"),
                    },
                    pagination: {
                        el: section.querySelector(".swiper-pagination"),
                        clickable: true,
                    },
                })
            })
        }
    }
}

export const init = carousels;